export const EXTERNAL_URL = {
  REGISTER: 'https://id.locker.io/register',
}
